import { fetchRequestWithTypes } from './index.js';

export const GET_PLANS_REQUEST = 'GET_PLANS_REQUEST';
export const GET_PLANS_SUCCESS = 'GET_PLANS_SUCCESS';
export const GET_PLANS_ERRORED = 'GET_PLANS_ERRORED';
// TODO: Remove this once Dynamic Tiers is fully launched
// (Remove hydration call in UniversalOnboardingApp.jsx and verify if a replacement is needed)
export const getPlans = () => {
	return fetchRequestWithTypes({
		types: [GET_PLANS_REQUEST, GET_PLANS_SUCCESS, GET_PLANS_ERRORED],
		request: {
			method: 'GET',
			path: `/concierge/api/v1/users/:uuid/plans`,
		},
	});
};

export const GET_DYNAMIC_PLANS_REQUEST = 'GET_DYNAMIC_PLANS_REQUEST';
export const GET_DYNAMIC_PLANS_SUCCESS = 'GET_DYNAMIC_PLANS_SUCCESS';
export const GET_DYNAMIC_PLANS_ERRORED = 'GET_DYNAMIC_PLANS_ERRORED';

export const getDynamicPlans = () => {
	return fetchRequestWithTypes({
		types: [
			GET_DYNAMIC_PLANS_REQUEST,
			GET_DYNAMIC_PLANS_SUCCESS,
			GET_DYNAMIC_PLANS_ERRORED,
		],
		request: {
			method: 'GET',
			path: `/customers/v1/subscriptions/plans`,
		},
	});
};

export const POST_USER_PLAN_REQUEST = 'POST_USER_PLAN_REQUEST';
export const POST_USER_PLAN_SUCCESS = 'POST_USER_PLAN_SUCCESS';
export const POST_USER_PLAN_ERRORED = 'POST_USER_PLAN_ERRORED';

export const postUserPlan = (body) => {
	return fetchRequestWithTypes({
		types: [POST_USER_PLAN_REQUEST, POST_USER_PLAN_SUCCESS, POST_USER_PLAN_ERRORED],
		request: {
			method: 'POST',
			path: '/customers/v1/subscriptions',
			body,
		},
	});
};

export const GET_USER_SUBSCRIPTION_REQUEST = 'GET_USER_SUBSCRIPTION_REQUEST';
export const GET_USER_SUBSCRIPTION_SUCCESS = 'GET_USER_SUBSCRIPTION_SUCCESS';
export const GET_USER_SUBSCRIPTION_ERRORED = 'GET_USER_SUBSCRIPTION_ERRORED';
// TODO: Remove this once Dynamic Tiers is fully launched
// (Remove hydration call in UniversalOnboardingApp.jsx and delete usages of this action's reducer)
// (New transition accounts for hydration logic - hasCurrentPlan)
export const getUserSubscription = (body) => {
	return fetchRequestWithTypes({
		types: [
			GET_USER_SUBSCRIPTION_REQUEST,
			GET_USER_SUBSCRIPTION_SUCCESS,
			GET_USER_SUBSCRIPTION_ERRORED,
		],
		request: {
			method: 'GET',
			path: '/concierge/api/v1/users/:uuid/subscriptions',
			body,
		},
	});
};

export const POST_USER_SUBSCRIPTION_REQUEST = 'POST_USER_SUBSCRIPTION_REQUEST';
export const POST_USER_SUBSCRIPTION_SUCCESS = 'POST_USER_SUBSCRIPTION_SUCCESS';
export const POST_USER_SUBSCRIPTION_ERRORED = 'POST_USER_SUBSCRIPTION_ERRORED';
// TODO: Remove this once Dynamic Tiers is fully launched
export const postUserSubscription = (body) => {
	return fetchRequestWithTypes({
		types: [
			POST_USER_SUBSCRIPTION_REQUEST,
			POST_USER_SUBSCRIPTION_SUCCESS,
			POST_USER_SUBSCRIPTION_ERRORED,
		],
		request: {
			method: 'POST',
			path: '/concierge/api/v1/users/:uuid/subscriptions',
			body,
		},
	});
};

export const PATCH_USER_SUBSCRIPTION_REQUEST = 'PATCH_USER_SUBSCRIPTION_REQUEST';
export const PATCH_USER_SUBSCRIPTION_SUCCESS = 'PATCH_USER_SUBSCRIPTION_SUCCESS';
export const PATCH_USER_SUBSCRIPTION_ERRORED = 'PATCH_USER_SUBSCRIPTION_ERRORED';
// TODO: Remove this once Dynamic Tiers is fully launched
export const patchUserSubscription = (subscriptionId, body) => {
	return fetchRequestWithTypes({
		types: [
			PATCH_USER_SUBSCRIPTION_REQUEST,
			PATCH_USER_SUBSCRIPTION_SUCCESS,
			PATCH_USER_SUBSCRIPTION_ERRORED,
		],
		request: {
			method: 'PATCH',
			path: `/concierge/api/v1/users/:uuid/subscriptions/${subscriptionId}`,
			body,
		},
	});
};
